import React from 'react';
import DefaultLayout from '../../../layouts/default';

// Import local compliance components
import IncidentComplianceOverview from './components/IncidentComplianceOverview';
import IncidentDashboardTables from './components/IncidentDashboardTables';
import IncidentDetailsDashboard from './components/IncidentDetailsDashboard';
import IncidentAuditFooterDashboard from './components/IncidentAuditFooterDashboard';

function IncidentComplianceCenter() {
  return (
    <DefaultLayout>
      <div className="flex flex-col gap-6 bg-slate-50 min-h-screen">
        {/* Metric Summary Ribbon Cards */}
        <IncidentComplianceOverview />

        {/* Aggregated Categorical and Locational Grid Summaries */}
        <IncidentDashboardTables />

        {/* Detailed Breakdown Panels and Distribution Pie Chart */}
        <IncidentDetailsDashboard />

        {/* Informational Subtext & Verified Auditing Action Trail Logs */}
        <IncidentAuditFooterDashboard />
      </div>
    </DefaultLayout>
  );
}

export default IncidentComplianceCenter;
